<template>
  <div>
    <!-- 标签核对 -->
    <el-dialog :title="$t('message.labelComparison')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="780px" center>
      <div class="content">
        <!-- 标签编码 -->
        <div class="row">
          <div class="label">
            <input type="text" v-model="code" onfocus="this.select()" :placeholder="$t('message.tagCoding')"
              @keyup.enter="entry">
          </div>
          <div class="val">
            <!-- 录入 -->
            <el-button type="primary" @click="entry"> {{ $t("message.entry") }}</el-button>
          </div>
        </div>
        <div class="table">
          <ol>
            <li class="flex05">
              NO
            </li>
            <!-- 扫描时间 -->
            <li>
              {{ $t("message.scanningTime") }}
            </li>
            <!-- 扫描条码 -->
            <li>
              {{ $t("message.scanBarCode") }}
            </li>
            <!-- 标签比对 -->
            <li>
              {{ $t("message.labelComparison") }}
            </li>
          </ol>
          <div class="list">
            <ul v-for="(item, index) in tableData" :key="index" :class="{ is_match: !item.is_match }">
              <li class="flex05">
                {{ item.rowNumber }}
              </li>
              <!-- 扫描时间 -->
              <li>
                {{ item.created_at }}
              </li>
              <!-- 扫描条码 -->
              <li>
                {{ item.code }}
              </li>
              <!-- 标签比对 -->
              <li>
                {{ item.is_match ? '匹配成功' : '未匹配' }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    fbaScanData: { type: Object },
  },
  data() {
    return {
      tableData: [],
      code: '',
      dialogVisible: false,
    };
  },
  created() {
    // this.fbaScanList()
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible) {
        this.code = ''
        this.fbaScanList()
      }
    }
  },
  methods: {
    fbaScanList() {
      let datas = {
        porder_sn: this.fbaScanData.porder_sn,
        porder_detail_tag_id: this.fbaScanData.porder_detail_tag_id,
        pageSize: 9999,
        page: 1
      }
      this.$api.porderApi.fbaScanList(datas).then(res => {
        this.tableData = res.data.data
      })
    },
    entry() {
      let datas = {
        porder_detail_tag_id: this.fbaScanData.porder_detail_tag_id,
        code: this.code
      }
      this.code = ''
      this.$api.porderApi.fbaScan(datas).then(res => {
        this.fbaScanList()
      })
    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;

  .row {
    display: flex;
    margin-bottom: 20px;

    .label {
      line-height: 40px;
      margin-right: 10px;
      width: 250px;


      input {
        width: 240px;
        height: 38px;
        border: 1px solid #ccc;
        padding-left: 10px;
        border-radius: 4px;
      }
    }

    .val {
      flex: 1;
    }
  }

  .table {
    border: 1px solid #edeff4;

    ol {
      display: flex;
    }

    ul {
      display: flex;
      padding: 0;
      border-bottom: 1px solid #edeff4;

      li {
        padding: 24px 0;
      }
    }

    .list {
      max-height: 500px;
      overflow-y: auto;
    }

    li {
      border-right: 1px solid #edeff4;

      &:nth-last-child(1) {
        border: 0;
      }
    }

    .flex05 {
      flex: 0.5;
    }
  }

  .is_match {
    background-color: red;
    color: #fff;

    li {
      font-size: 20px;
    }
  }
}
</style>